import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective, SmartSearchState } from 'mbs-ui-kit';
import { CompaniesFacade } from 'mbs-ui-shared@facades/companies.facade';
import { PerPageSize } from 'mbs-ui-shared@models';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { map } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-companies-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchCompaniesTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchCompaniesTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;
  companies = inject(CompaniesFacade);

  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();
    this.i18nPipe = i18nPipe;

    this.companies.loadData();
  }
  public tag = SmartSearchTemplateName.Company;
  public enableCacheStorage = true;
  public items = (state: SmartSearchState) => {
    const request$ = state.leftCaretValue
      ? this.companies.getCompanies({ search: state.leftCaretValue, limit: PerPageSize.Small }).pipe(map((values) => values?.data ?? []))
      : toObservable(this.companies.dataWhenLoaded).pipe(map((values) => values));
    return request$.pipe(
      map((values) =>
        values.map((value) => ({
          value: value.id,
          searchText: value.name,
          translation: null,
          cachedValue: { id: value.id }
        }))
      )
    );
  };
}
